const React = require('react');
const css = require('./module.scss');
const Head = require('./head');
const Foot = require('./foot');
const Menu = require('./menu');
const Path = require('./path');
const $ = require('jquery');
const SurveyButton = require('../surveyButton');

var Frame = React.createClass({
    getInitialState: function() {
        return {};
    },
    componentDidMount: function() {
        window.onresize = function() {
            var height =  $(window).height();
            $(this.refs.container).css('min-height', (height - 80) + 'px');
            $(".fp-menu").css('min-height', (height - 70) + 'px');
        }.bind(this);

        window.onresize();
    },
    handleSurveyClick: function() {
        window.open('https://www.wjx.cn/vm/t2mFoCR.aspx#', '_blank');
    },
    render: function() {
        return <div className = 'fp-page'>
            <Head menu={this.props.headMenu.items}
                activeId={this.props.headMenu.activeId}
                userName={this.props.userName}
                logoutClick={this.props.logoutClick}
                searchInput={this.props.searchInput}
                editPassword={this.props.editPassword}
            />
            <div ref="body" className='fp-body clearfix'>
                <Menu ref="menu" data={this.props.menu.items} activeId={this.props.menu.activeId}/>
                <div className='fp-container' ref="container" id="J_container">
                    <Path path={this.props.path} isShowBack={this.props.isShowBack}/>
                    {this.props.children}
                    {/*<div className="fp-footer">
                    	<p >技术支持：<a href='http://www.caih.com/' target="_blank">中国东信</a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;<a href='https://www.hisugar.com/' target="_blank">泛糖科技</a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;<a href='http://www.hcgis.cn/' target="_blank">广州海川</a></p>
                        <p><a href='https://beian.miit.gov.cn/#/Integrated/index' target="_blank">桂ICP备16005301号-21</a></p>
                    </div>*/}
                </div>
                {/*<div className="fp-footer">
                	<p>技术支持：<a href='http://www.caih.com/' target="_blank">中国东信</a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;<a href='https://www.hisugar.com/' target="_blank">泛糖科技</a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;<a href='http://www.hcgis.cn/' target="_blank">广州海川</a></p>
                </div>
                */}
            </div>
            {/*<Foot/>*/}
            <SurveyButton onClick={this.handleSurveyClick} />
        </div>;
    }
});

module.exports = Frame;








// WEBPACK FOOTER //
// ./component/frame/frame_nofoot.js